const services = [
  {
    number: '01',
    icon: 'ri-search-eye-line',
    title: 'Investigation & Analysis',
    description:
      'We begin every engagement by deeply understanding your business, your users, and your constraints. We map requirements, identify risks, and design the most pragmatic solution – so you never pay for features you don\'t need.',
    tags: ['Requirements Gathering', 'Feasibility Analysis', 'Technical Roadmap'],
  },
  {
    number: '02',
    icon: 'ri-code-s-slash-line',
    title: 'Web Application Development',
    description:
      'Custom web applications built from scratch using modern frameworks and proven engineering practices. We handle everything from database architecture to UI/UX – delivering products that are fast, reliable, and maintainable.',
    tags: ['React', 'Node.js', 'TypeScript', 'PostgreSQL'],
  },
  {
    number: '03',
    icon: 'ri-smartphone-line',
    title: 'Mobile App Development',
    description:
      'Cross-platform and native mobile applications for iOS and Android. We focus on performance, intuitive UX, and seamless integration with your backend systems and third-party services.',
    tags: ['React Native', 'iOS', 'Android', 'Flutter'],
  },
  {
    number: '04',
    icon: 'ri-building-line',
    title: 'Software Architecture & Design',
    description:
      'Solid architectural foundations that enable your product to scale. We design microservices, APIs, and system integrations that reduce technical debt and allow your team to move fast without breaking things.',
    tags: ['System Design', 'API Design', 'Microservices', 'Scalability'],
  },
  {
    number: '05',
    icon: 'ri-cloud-line',
    title: 'Cloud & DevOps Solutions',
    description:
      'Cloud infrastructure setup, CI/CD pipelines, containerization, and monitoring. We automate your deployment workflows and ensure your infrastructure is secure, reliable, and cost-efficient.',
    tags: ['AWS', 'Docker', 'Kubernetes', 'CI/CD'],
  },
  {
    number: '06',
    icon: 'ri-shield-check-line',
    title: 'Quality Assurance & Testing',
    description:
      'Comprehensive QA processes including automated testing, manual testing, performance testing, and security audits. We ensure your product works flawlessly before and after launch.',
    tags: ['Automated Testing', 'Performance', 'Security Audits'],
  },
  {
    number: '07',
    icon: 'ri-refresh-line',
    title: 'Legacy System Modernization',
    description:
      'We assess, refactor, and migrate legacy systems to modern stacks without disrupting your operations. Reduce technical debt, improve performance, and unlock new capabilities.',
    tags: ['Migration', 'Refactoring', 'Integration'],
  },
  {
    number: '08',
    icon: 'ri-shake-hands-line',
    title: 'Long-Term Partnership',
    description:
      'Our best relationships are long-term. We act as an extension of your team – providing ongoing development, maintenance, strategic guidance, and proactive improvements as your product evolves.',
    tags: ['Maintenance', 'Support', 'Continuous Development'],
  },
];

export default function ServicesGrid() {
  return (
    <section className="bg-[#070B14] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-[#1A2740]">
          {services.map((service) => (
            <div
              key={service.number}
              className="bg-[#070B14] hover:bg-[#0C1525] transition-colors duration-200 p-8 lg:p-10 group"
            >
              <div className="flex items-start gap-4 mb-5">
                <span className="text-[#1A2F50] font-display font-bold text-2xl w-10 flex-shrink-0 pt-0.5">
                  {service.number}
                </span>
                <span className="w-10 h-10 flex items-center justify-center bg-[#1E3A5F]/40 group-hover:bg-[#3B82F6]/15 rounded-lg transition-colors duration-200 flex-shrink-0">
                  <i className={`${service.icon} text-[#3B82F6] text-xl`}></i>
                </span>
              </div>
              <h3 className="font-display font-bold text-white text-lg mb-3 leading-snug">
                {service.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed mb-5">
                {service.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {service.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs text-[#3B82F6]/80 bg-[#3B82F6]/8 border border-[#3B82F6]/15 px-2.5 py-1 rounded-full whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
